import { sendWebsocketMessage } from "../../../../../../App";

export const importTradePlan = ({ hash }) => {
    const msg = {
        messageType: 'importTemplate',
        hash
    };
    sendWebsocketMessage(msg);
};

